import { useNavigate } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

// Glass-blur lock over premium content. Shows the feature blurred (to create desire) with a glowing
// upgrade CTA on top. When `locked` is false, renders children normally.
export function PaywallOverlay({
  locked = true,
  title = "Premium feature",
  description = "Upgrade to unlock this.",
  ctaLabel = "Upgrade",
  to = "/app/membership",
  onUpgrade,
  icon: Icon = Sparkles,
  className = "",
  children,
  testid = "paywall-overlay",
}) {
  const navigate = useNavigate();
  if (!locked) return children;
  const go = () => (onUpgrade ? onUpgrade() : navigate(to));

  return (
    <div className={cn("relative overflow-hidden rounded-3xl", className)} data-testid={testid}>
      <div className="pointer-events-none select-none opacity-60 blur-[6px] saturate-50" aria-hidden>
        {children}
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-bloq-bg/70 p-6 text-center backdrop-blur-xl">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-bloq-mint/30 bg-bloq-mint/10 text-bloq-mint shadow-[0_0_24px_rgba(1,250,189,0.25)]">
          <Icon className="h-6 w-6" />
        </span>
        <div>
          <div className="flex items-center justify-center gap-1.5 text-base font-bold text-white">
            <Lock className="h-3.5 w-3.5 text-bloq-mint" /> {title}
          </div>
          <p className="mt-1 max-w-xs text-sm text-bloq-muted">{description}</p>
        </div>
        <button
          onClick={go}
          className="mt-1 rounded-full bloq-gradient px-6 py-2.5 text-sm font-bold text-bloq-bg transition-opacity hover:opacity-90"
          data-testid="paywall-upgrade-btn"
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}
